import { render, staticRenderFns } from "./DetailGLTransaction.vue?vue&type=template&id=10d243e6"
import script from "./DetailGLTransaction.vue?vue&type=script&lang=js"
export * from "./DetailGLTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports